import { render, staticRenderFns } from "./CommonAppItemPlatform.vue?vue&type=template&id=5b946a96&scoped=true&"
import script from "./CommonAppItemPlatform.vue?vue&type=script&lang=ts&"
export * from "./CommonAppItemPlatform.vue?vue&type=script&lang=ts&"
import style0 from "./CommonAppItemPlatform.vue?vue&type=style&index=0&id=5b946a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b946a96",
  null
  
)

export default component.exports